import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';
import { AuthService } from '@auth0/auth0-angular';

@Injectable({
  providedIn: 'root'
})

export class AppService {
  baseUrl: string;
  crmType: string;
  apiUrl: string;
  code: string;

  constructor(private http: HttpClient, private router: Router, public auth: AuthService) {
    this.apiUrl = environment.apiUrl;
    this.baseUrl = window.location.host.split('.').splice(1).join('.');
    if (!this.baseUrl) {
      this.baseUrl = "ghc.health";
      this.crmType = "marsAgentCrm";
    } else if (this.baseUrl == 'ghc.health') {
      this.baseUrl = "ghc.health";
      this.crmType = "marsAgentCrm";
    } else if (this.baseUrl == 'saturn.health') {
      this.baseUrl = "saturn.health";
      this.crmType = "saturnAgentCrm";
    } else {
      this.baseUrl = "ghc.health";
      this.crmType = "marsAgentCrm";
    }
  }

  public getBaseUrl() {
    return this.baseUrl;
  }

  public getCategories(): Promise<any> {
    return this.http.get(`https://${this.baseUrl}/collections.json`).toPromise();
  }

  public getProductsByCategory(handle: string): Promise<any> {
    return this.http.get(`https://${this.baseUrl}/collections/${handle}/products.json?limit=250`).toPromise();
  }

  public LogOut() {
    localStorage.clear();
    sessionStorage.clear();
    this.auth.logout({ returnTo: '' });
  }

  public getProducts(): Promise<any> {
    return this.http.get(`https://${this.baseUrl}/products.json?limit=250`).toPromise();
  }

  public clickUPAuthorization() {
    window.location.href = `https://app.clickup.com/api?client_id=5MBJVT794SZRPXXTX05T99JI5N1JKVN0&redirect_uri=${location.hostname}/redirect/auth`
  }

  public clickUPoauth(code: any): Observable<any> {
    const param = new HttpParams()
      .set('code', code)
    return this.http.post('https://zdwhortq6e.execute-api.ap-south-1.amazonaws.com/production/clickupauth/getUser', param);
  }

  public submitLead(data: any): Observable<any> {
    const param = new HttpParams()
      .set('data', JSON.stringify({ ...data, ...{ brand: this.baseUrl } }))
    return this.http.post('https://zdwhortq6e.execute-api.ap-south-1.amazonaws.com/production/clickupauth/submitLead', param);
  }

  public productsList(): Promise<any> {
    return this.http.get(`https://${this.baseUrl}/products.json?limit=250`).toPromise();
  }

  public storeAgentCrm(data): Promise<any> {
    let body = {
      fName: data.fName,
      lName: data.lName,
      email: data.email,
      number: data.number,
      age: data.age,
      weight: data.weight,
      height: data.height,
      category: data.category,
      BMI: data.BMI,
      user_survey: data.user_survey,
      type: data.type,
      recommendation: data.recommendation
    }
    return this.http.post(`${this.apiUrl}crm/${this.crmType}`, body).toPromise();
  }

  public createCrmOrder(lines, customer, discount, shipping): Observable<any> {
    let accUser = JSON.parse(localStorage.getItem('user'));

    let body = {
      "line_items": lines,
      "customer": {
        "first_name": customer.first_name,
        "last_name": customer.last_name,
        "email": customer.email,
        "phone": "+91" + customer.phone
      },
      "billing_address": customer,
      "shipping_address": customer,
      "discount_codes": discount,
      "note": "Agent Crm",
      "tags": accUser ? accUser.email : "null",
      "brand": this.crmType,
      "shipping": shipping
    }
    return this.http.post(`${this.apiUrl}crm/createCrmOrder`, body);
  }

  public pincodeChecker(data): Promise<any> {
    let brand = this.crmType == 'marsAgentCrm' ? 'Mars' : 'Saturn';

    let body = {
      "pincode": data.pincode,
      "brand": brand
    }
    return this.http.post(`${this.apiUrl}device/pincode`, body).toPromise();
  }

  public shippingZones(): Promise<any> {
    let body = {
      brandName: this.crmType
    }
    return this.http.post(`${this.apiUrl}crm/shippingZones`, body).toPromise();
  }

  public createCartMutation(): Observable<any> {
    let body = {
      brandName: this.crmType
    }
    return this.http.post(`${this.apiUrl}crm/createCartMutation`, body);
  }

  public shortenLink(link): Observable<any> {
    let body = {
      link: link
    }
    return this.http.post(`${this.apiUrl}device/shortenLink`, body);
  }

  public addToCartMutation(lines, cartId): Observable<any> {
    let body = {
      brandName: this.crmType,
      cartId: cartId,
      lines: lines
    }
    return this.http.post(`${this.apiUrl}crm/addToCartMutation`, body);
  }

  public updateLineMutation(lines, cartId): Observable<any> {
    let body = {
      brandName: this.crmType,
      cartId: cartId,
      lines: lines
    }
    return this.http.post(`${this.apiUrl}crm/updateLineMutation`, body);
  }

  public removeFromCartMutation(lineIds, cartId): Observable<any> {
    let body = {
      brandName: this.crmType,
      cartId: cartId,
      lineIds: lineIds
    }
    return this.http.post(`${this.apiUrl}crm/removeFromCartMutation`, body);
  }

  public getCartMutation(cartId): Observable<any> {
    let body = {
      brandName: this.crmType,
      cartId: cartId
    }
    return this.http.post(`${this.apiUrl}crm/getCartMutation`, body);
  }

  public applyDiscountCodeMutation(discountCodes, cartId): Observable<any> {
    let body = {
      brandName: this.crmType,
      cartId: cartId,
      discountCodes: discountCodes
    }
    return this.http.post(`${this.apiUrl}crm/applyDiscountCodeMutation`, body);
  }

  public createCheckout(data): Observable<any> {
    let body = {
      brandName: this.crmType,
      data: data
    }
    return this.http.post(`${this.apiUrl}crm/createCheckout`, body);
  }

  // public removeCheckoutItems(data): Observable<any> {
  //   let body = {
  //     brandName: this.crmType,
  //     data: data
  //   }
  //   return this.http.post(`${this.apiUrl}crm/removeCheckoutItems`, body);
  // }

  // public removeCheckoutDiscount(data): Observable<any> {
  //   let body = {
  //     brandName: this.crmType,
  //     data: data
  //   }
  //   return this.http.post(`${this.apiUrl}crm/removeCheckoutDiscount`, body);
  // }

  // public createCheckoutDiscount(data): Observable<any> {
  //   let body = {
  //     brandName: this.crmType,
  //     data: data
  //   }
  //   return this.http.post(`${this.apiUrl}crm/createCheckoutDiscount`, body);
  // }
}